import { Text } from "../../../../components/common/typography";
import { DocumentUploadItem } from "./document-upload-item";
import type { UserDtoDocumentsInnerTypeEnum } from "../../../../api/api";

interface RequiredDocumentsSectionProps {
  documentTypes: UserDtoDocumentsInnerTypeEnum[];
  uploading: Record<UserDtoDocumentsInnerTypeEnum, boolean>;
  uploadProgress?: Record<UserDtoDocumentsInnerTypeEnum, number>;
  selectedFiles: Record<UserDtoDocumentsInnerTypeEnum, File | null>;
  onFileSelect: (
    type: UserDtoDocumentsInnerTypeEnum,
    file: File | null
  ) => void;
  onFileRemove: (type: UserDtoDocumentsInnerTypeEnum) => void;
  onConfirmUpload: (type: UserDtoDocumentsInnerTypeEnum) => void;
  hideUploadButton?: boolean;
  uploadedDocuments?: Record<UserDtoDocumentsInnerTypeEnum, boolean>;
}

export function RequiredDocumentsSection({
  documentTypes,
  uploading,
  selectedFiles,
  onFileSelect,
  onFileRemove,
  onConfirmUpload,
  hideUploadButton = false,
  uploadedDocuments = {
    CR: false,
    TAX_CARD: false,
  },
  uploadProgress,
}: RequiredDocumentsSectionProps) {
  if (documentTypes.length === 0) {
    return null;
  }

  return (
    <div>
      <Text variant="bodyLg" tone="dark" className="mb-3">
        Required Documents
      </Text>
      <div className="space-y-3">
        {documentTypes.map((type) => (
          <DocumentUploadItem
            key={type}
            type={type}
            isUploading={uploading[type]}
            progress={uploadProgress?.[type]}
            selectedFile={selectedFiles[type]}
            onFileSelect={onFileSelect}
            onFileRemove={onFileRemove}
            onConfirmUpload={onConfirmUpload}
            hideUploadButton={hideUploadButton}
            isUploaded={uploadedDocuments[type] || false}
          />
        ))}
      </div>
    </div>
  );
}
